import React, { useState, useEffect } from "react";
import axiosConfig from "../../Service/axiosConfig";
import "../Shopidy/VerticalBannerView.css";
const VerticalBannerView = ({ Setlogin, LoginAccount, data, subcategory }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);

  useEffect(() => {
    if (!subcategory || subcategory.length === 0) return;
    setLoading(true);
    setProducts([]);

    const fetchProductsForSubcategories = async () => {
      try {
        const subcategories = Array.isArray(subcategory)
          ? subcategory
          : [subcategory];
        const responses = await Promise.all(
          subcategories.map(async (sub) => {
            const response = await axiosConfig.get(
              `/catlog/products/?subcategory=${sub}&page_size=7&store=2&is_suspended=false`
            );
            return response.data.results.slice(0, 8);
          })
        );
        setProducts(responses.flat());
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductsForSubcategories();
  }, [subcategory]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1020);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="product-grid-container">
      {/* Left Banner */}
      <div className="left-banner">
        <div className="banner-card left-banner-img">
          {data?.slice(0, 1).map((imgs, index) => (
            <div key={index}>
              <img src={imgs?.image__image || imgs?.image} alt="Left Banner" />
            </div>
          ))}
        </div>
        <div className="left-banner-data">
          {products?.slice(0, 4).map((product, index) => (
            <div className="product-item vertical-banner" key={index}>
              <div className="vertical-banner">
                <img
                  src={product.image ? product.image.image : product.image}
                  alt={product.name}
                />
              </div>
              <p className="name">{product.name}</p>
              <div className="product-actions">
                <div className="p-price">
                  {product.offer_price && product.offer_price > 0 ? (
                    <>
                      <p className="price">₹{product.offer_price}</p>
                      <p className="produc-price">₹{product.price}</p>
                    </>
                  ) : (
                    <p className="price">₹{product.price}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
          {products.length === 0 && !loading && <p>No products available</p>}
        </div>
      </div>

      {/* Right Banner */}
      <div className="right-banner">
        <div className="banner-card right-banner-img">
          {data?.slice(1).map((imgs, ind) => (
            <div key={ind}>
              <img src={imgs?.image__image || imgs?.image} alt="Right Banner" />
            </div>
          ))}
        </div>
        <div className="right-banner-data">
          {products?.slice(4, 8).map((product, index) => (
            <div className="product-item vertical-banner" key={index}>
              <div className="vertical-banner">
                <img
                  src={product.image ? product.image.image : product.image}
                  alt={product.name}
                />
              </div>
              <p className="name">{product.name}</p>
              <div className="product-actions">
                <div className="p-price">
                  {product.offer_price && product.offer_price > 0 ? (
                    <>
                      <p className="price">₹{product.offer_price}</p>
                      <p className="produc-price">₹{product.price}</p>
                    </>
                  ) : (
                    <p className="price">₹{product.price}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
          {products.length === 0 && !loading && <p>No products available</p>}
        </div>
      </div>
    </div>
  );
};

export { VerticalBannerView };
